<template>
  <upload
    :auto-process-queue="true"
    :api-url="`api/v2/customers/${customerId}/documents`"
    :border="false"
    :show-empty-state="true"
    :custom-empty-state="false"
    :options="{
      addedfile: fileAdded,
    }"
    :include-styling="false"
    :disabled="disabled"
    @upload-error="uploadError"
    @upload-file-success="uploadFileSuccess"
    @file-upload-progress="updateFileProgress"
  >
    <template slot="empty-state">
      <i-button text="Upload" size="lg" :disabled="disabled"></i-button>
    </template>
  </upload>
</template>

<script>
import { iButton } from '@inscribe/signal';
import Upload from './Upload';

export default {
  components: {
    Upload,
    iButton,
  },
  props: {
    customerId: {
      type: String,
      default: null,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    fileAdded(file) {
      this.$emit('file-added', file);
    },
    uploadError(message, files) {
      this.$emit('upload-error', message, files);
    },
    uploadFileSuccess(file, response) {
      this.$emit('upload-file-success', file, response);
    },
    updateFileProgress(file, uploadProgress, totalBytesSent) {
      this.$emit('file-upload-progress', file, uploadProgress, totalBytesSent);
    },
  },
};
</script>

<style scoped></style>
